import { Tenant } from './../../../model/tenant/tenant';
import { NecTenantService } from './../../../service/tenant/tenant.service';
import { Client } from '../../../model/tenant/client.enum';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NecAuthService } from './../../../service/auth/auth.service';
import { NecSlideImage } from './../../slide/slide-image';
import { Router } from '@angular/router';
import { UserService } from '../../../service/user/user.service';
import { AuthorityType } from '../../../model';


@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class NecHomeComponent implements OnInit {
  slideImages: NecSlideImage[];
  hasCustomizeImages: Boolean = false;
  showingImageIndex: number;

  constructor(
    private authService: NecAuthService,
    private userService: UserService,
    private router: Router,
    private tenantService: NecTenantService) {
  }

  ngOnInit() {

    // è¯»åå»é¢èªå®ä¹å°é¢è½®æ­å¾çä¿¡æ¯
    if (this.authService.authenticate() && this.userService.getAuthority() !== AuthorityType.ROLE_PLATFORM_ADMIN) {
      this.tenantService.getTenant()
        .subscribe(data => {
          this.getSildeImages(data);
        });
    } else {
      this.setDefaultSilderImages();
    }
  }

  /**
   * è·åbannerå¾
   */
  private getSildeImages(tenant: Tenant): void {
    let tenantCustomizeImages = tenant ? tenant.pictures : [];
    let pcCustonizeImages = tenantCustomizeImages.filter(image => image.client === Client.PC);
    // å¦ææ²¡æå»é¢èªå®ä¹çè½®æ­å¾, åè®¾ç½®é»è®¤çå°é¢è½®æ­å¾
    if (pcCustonizeImages.length === 0) {
      this.setDefaultSilderImages();
    }
    else {
      this.slideImages = pcCustonizeImages.map(image => {
        return new NecSlideImage(image.mediaInfo.url, '');
      });
      this.hasCustomizeImages = true;
    }
  }

  /**
   * è®¾ç½®é»è®¤banner
   */
  private setDefaultSilderImages() {
    this.slideImages = [
      {
        src: 'assets/images/common/home/home/banner.png',
        link: ''
      },
      {
        src: 'assets/images/common/home/home/mooc-test.png',
        link: '/mooc-test'
      },
      // {
      //   src: 'assets/images/common/home/home/home.png',
      //   link: '/xiao-xiang'
      // },
      {
        src: 'assets/images/common/home/home/slide1.png',
        link: '',
        showDownloadBrowserBtn: true
      }
    ];
  }
}
